module.exports = __webpack_public_path__ + "Qqx6JfPDtXSiUWszk/icon_info.svg";